import { useState } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Plus } from 'lucide-react'
import { RouteErrorFallback } from '@/components/ErrorBoundary'
import {
  PageContainer, PageCard, PageHeader, PageHeaderContent,
  PageHeaderTitle, PageHeaderHeading, PageHeaderDescription, PageContent
} from '@/components/ui/page'
import { Button } from '@/components/ui/button'
import { BillingOrganizationsTable } from '@/components/admin/billing/BillingOrganizationsTable'
import { ProvisionOrgDialog } from '@/components/admin/organizations/ProvisionOrgDialog'

export const Route = createFileRoute('/admin/organizations/')({
  component: OrganizationsAdmin,
  errorComponent: RouteErrorFallback,
})

function OrganizationsAdmin() {
  const [provisionOpen, setProvisionOpen] = useState(false)

  return (
    <>
    <PageContainer>
      <PageCard>
        <PageHeader>
          <PageHeaderContent>
            <PageHeaderTitle>
              <PageHeaderHeading>Organisationen</PageHeaderHeading>
              <PageHeaderDescription>Verwaltung aller Organisationen</PageHeaderDescription>
            </PageHeaderTitle>
            <Button size="sm" onClick={() => setProvisionOpen(true)}>
              <Plus className="h-4 w-4 mr-1" />
              Organisation hinzufügen
            </Button>
          </PageHeaderContent>
        </PageHeader>
        <PageContent className="p-4">
          <BillingOrganizationsTable className="flex-1 min-h-0" detailsRoute="/admin/organizations/$orgId" defaultPageSize={25} showDelete />
        </PageContent>
      </PageCard>
    </PageContainer>

    <ProvisionOrgDialog open={provisionOpen} onOpenChange={setProvisionOpen} />
    </>
  )
}
